/**
 * O anel aberto e ponto âmbar (handoff de UI/UX, ADR 039). Desde a marca Grifo
 * (ADR 041) ele não é mais o logotipo: ficou como o indicador de espera.
 *
 * O anel é `currentColor` e o ponto é a cor do ritual, pela folha — assim a
 * marca acompanha o tema sem uma segunda versão. Os atributos de desenho são
 * geometria do SVG, não estilo, e passam pela CSP sem `style` nenhum.
 *
 * `girando` é o carregamento: o anel gira e o ponto pulsa. Sozinha, sem o
 * nome, ela é decorativa — quem a usa como indicador de espera põe o texto ao
 * lado ou o rótulo no contêiner com `aria-busy`.
 */
export function Marca({ girando = false, className }: { girando?: boolean; className?: string }) {
  const classes = ["marca", girando ? "marca--girando" : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <svg className={classes} viewBox="0 0 28 28" fill="none" aria-hidden="true" focusable="false">
      <circle
        className="marca__anel"
        cx="14"
        cy="14"
        r="10"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeDasharray="48 14.8"
      />
      <circle className="marca__ponto" cx="22.2" cy="6.4" r="2.9" />
    </svg>
  );
}

/**
 * O wordmark do Grifo (ADR 041): a palavra "grifo" em Kalam 700 sobre uma
 * faixa de marca-texto, e o ponto âmbar logo depois — o acento que veio do
 * logotipo antigo. É o nome da casa escrito do jeito que o app escreve tudo.
 *
 * A faixa e o ponto são desenho da folha (`caderno.css`, tokens
 * `--grifo-faixa` e `--marca-ponto`), nada de atributo `style`. `compacto` é a
 * letra só, para a lateral recolhida.
 */
export function Grifo({
  tamanho = "lateral",
  compacto = false,
  className,
}: {
  tamanho?: "lateral" | "cabecalho" | "hero";
  compacto?: boolean;
  className?: string;
}) {
  const classes = ["grifo", `grifo--${tamanho}`, compacto ? "grifo--compacto" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={classes}>
      <span className="grifo__palavra">{compacto ? "g" : "grifo"}</span>
      {!compacto && <span className="grifo__ponto" aria-hidden="true" />}
    </span>
  );
}
